// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cb389066","511":"4808711d","590":"80e33631","746":"89235781","886":"b54ff013","896":"1bdebdfa","929":"e4a23444","930":"f7f34d7e"}[chunkId] + ".chunk.js";
};